import React from 'react';

const Introduce = () => (
  <div className="d-flex flex-column text-center text">
    <h3 className=" font-weight-bold">درس‌آپ</h3>
    <p className="font-weight-normal">
      در پنل مدیریت درس آپ شما با توجه به زمینه فعالیت خود در هر سازمان میتوانید امکانات مختلف مدیریتی، آموزشی و
      درآمدزایی داشته باشید.
    </p>
    <p className="font-weight-light">پس با انتخاب زمینه فعالیت خود شروع کنید</p>
  </div>
);

export default Introduce;
